import { render, staticRenderFns } from "./LeadCreation.vue?vue&type=template&id=04a8a5af&scoped=true"
import script from "./LeadCreation.vue?vue&type=script&lang=ts"
export * from "./LeadCreation.vue?vue&type=script&lang=ts"
import style0 from "./LeadCreation.vue?vue&type=style&index=0&id=04a8a5af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a8a5af",
  null
  
)

export default component.exports